import { useEffect, useRef, useState } from 'react'
import Marquee from 'react-fast-marquee'
import { useTranslation } from 'react-i18next'
import SVG from 'react-inlinesvg'
import { useNavigate } from 'react-router'
import 'swiper/css'

import Button from '@/components/Button'
import View from '@/layout/View'

import { useTheme } from '../../lib/hooks'
import useCheckout from '../Checkout/hooks/useCheckout'
import { ScannerCta, ScannerLogo, ScannerSlider, ScannerSliderImage, ScannerWrapper, ScannerProvider } from './Scanner.styles'
import ScannerIndicator from './ScannerIndicator'
import withScanner from './withScanner'

const Scanner = () => {
  const { t } = useTranslation()
  const { reset } = useCheckout()
  const navigate = useNavigate()
  const themes = useTheme()
  const [isPortrait, setIsPortrait] = useState(false)
  const imgRef = useRef(null)
  const [clickCount, setClickCount] = useState(0)
  const clickTimerRef = useRef(null)

  const checkOrientation = () => {
    const isPortraitOrientation = window.matchMedia('(orientation: portrait)').matches
    setIsPortrait(isPortraitOrientation)
    console.log('Orientation:', { isPortrait: isPortraitOrientation })
  }

  useEffect(() => {
    const mediaQuery = window.matchMedia('(orientation: portrait)')
    checkOrientation()

    mediaQuery.addEventListener('change', checkOrientation)
    return () => mediaQuery.removeEventListener('change', checkOrientation)
  }, [])

  useEffect(() => {
    reset()
  }, [])

  const handleLogoClick = () => {
    setClickCount(prev => prev + 1)

    if (clickTimerRef.current) {
      clearTimeout(clickTimerRef.current)
    }

    clickTimerRef.current = setTimeout(() => {
      setClickCount(0)
    }, 3000)

    if (clickCount + 1 === 5) {
      if (window.BtDevice && window.BtDevice.clearSettings) {
        window.BtDevice.clearSettings()
        console.log('BtDevice settings cleared')
      }
      setClickCount(0)
      clearTimeout(clickTimerRef.current)
    }
  }

  return (
    <View theme="LIGHT">
      <ScannerWrapper>
        <ScannerLogo>
          {themes.assets.logo && <SVG src={themes.assets.logo}></SVG>}
          {themes.assets.logoJpg && <img src={themes.assets.logoJpg} alt='logo'></img>}
          {themes.additionalInfo && (
            <div style={{ 
              marginTop: '1rem', 
              textAlign: 'center',
              fontSize: '0.9rem',
              color: '#666'
            }}>
              <p style={{ margin: '0 0 0.5rem 0' }}>{themes.additionalInfo.text}</p>
              <div style={{ 
                display: 'flex', 
                justifyContent: 'center', 
                gap: '1.5rem',
                fontWeight: '500',
                color: themes.colors.global
              }}>
                {themes.additionalInfo.links.map((link, index) => (
                  <span key={index}>{link}</span>
                ))}
              </div>
            </div>
          )}
        </ScannerLogo>
        <ScannerSlider>
          {themes.staticHome ? (
            <ScannerSliderImage isPortrait={isPortrait}>
              <img ref={imgRef} src={themes.assets.home} alt="Scanner" />
            </ScannerSliderImage>
          ) : (
            <Marquee>
              <ScannerSliderImage isPortrait={isPortrait}>
                <img ref={imgRef} src={themes.assets.home} alt="Scanner" />
              </ScannerSliderImage>
            </Marquee>
          )}
        </ScannerSlider>
        <ScannerIndicator />
        <ScannerCta>
          <Button variant="primary" onClick={() => navigate('/checkout')}>
            {t('touchToStart')}
          </Button>
        </ScannerCta>
        <ScannerProvider>
          Powered by:
          <img src="/img/berg-regions.svg" alt="Berg Pay" onClick={handleLogoClick} />
        </ScannerProvider>
      </ScannerWrapper>
    </View>
  )
}

export default withScanner(Scanner)
